import { render, staticRenderFns } from "./ButtonMain.vue?vue&type=template&id=2f647f82"
import script from "./ButtonMain.vue?vue&type=script&lang=js"
export * from "./ButtonMain.vue?vue&type=script&lang=js"
import style0 from "./ButtonMain.vue?vue&type=style&index=0&id=2f647f82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports